<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';

export default {
    name: 'gpt-chatbox-knowledge',
    components: { mic },
    data () {
        return {
            prompt: '',
            recording: false,
            MODEL_LIST
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        // 是否展示简洁的输入对话框
        simpleChatBox: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        }
    },
    mounted () {
        this.prompt = this.input;
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        send () {
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }
            this.$emit('knowledgeAsk', { input: this.prompt });
            this.prompt = '';
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';
</style>
